import { types } from 'mobx-state-tree';

import { Contact, partiallyUpdateModel } from '../definitions/Common';
import DriverRelationValues from '../definitions/DriverRelationValues';
import OccupationValues from '../definitions/OccupationValues';
import MaritalStatusValues from '../definitions/MaritalStatusValues';
import TrafficConviction from './TrafficConviction';
import PolicyCancellation from './PolicyCancellation';
import AccidentClaim from './AccidentClaim';
import LicenceSuspension from './LicenceSuspension';
import LicenceON from './LicenceON';
import LicenceAB from './LicenceAB';
import LicenceQC from './LicenceQC';


const Driver = Contact
    .named('Driver')
    .props({
        id: types.identifier,

        relationToPrimaryInsured: types.maybeNull(types.enumeration(
            Object.values(DriverRelationValues),
        )),
        occupation: types.maybeNull(types.enumeration(
            Object.values(OccupationValues),
        )),
        maritalStatus: types.maybeNull(types.enumeration(
            Object.values(MaritalStatusValues),
        )),

        licensing: types.maybeNull(types.union(
            LicenceAB,
            LicenceON,
            LicenceQC,
        )),

        everInsured: types.maybeNull(types.boolean),
        firstInsuranceDate: types.maybeNull(types.string),
        currentlyInsured: types.maybeNull(types.boolean),
        lastPolicyExpire: types.maybeNull(types.string),
        sameInsurer: types.maybeNull(types.boolean),
        lastPolicyStart: types.maybeNull(types.string),
        currentInsuranceAmount: types.maybeNull(types.number),
        policyStart: types.maybeNull(types.string),

        trafficConvictions: types.array(TrafficConviction),
        policyCancellations: types.array(PolicyCancellation),
        accidentClaims: types.array(AccidentClaim),
        licenceSuspensions: types.array(LicenceSuspension),
    })
    .views(self => ({
        get isValid() {
            if (self.firstName == null
                || self.lastName == null
                || self.dob == null
                || self.gender == null
                || self.maritalStatus == null
                || self.relationToPrimaryInsured == null
                || self.licensing == null
                || self.occupation == null
                || self.everInsured == null
            ) {
                return false;
            }

            if (self.relationToPrimaryInsured === DriverRelationValues.PRIMARY && self.policyStart == null) {
                return false;
            }
                
            if (self.everInsured === true) {
                if (self.firstInsuranceDate == null || self.currentlyInsured == null) {
                    return false;
                }
                if (self.currentlyInsured === true && self.sameInsurer == null) {
                    return false;
                }
            }

            return true;
        },
        get isPrimaryDriver() {
            return self.relationToPrimaryInsured === DriverRelationValues.PRIMARY;
        },
        get fullName() {
            return `${self.firstName} ${self.lastName}`;
        },
    }))
    .actions(self => ({
        update(values) {
            partiallyUpdateModel(self, values);
        },
    }));

export default Driver;
